import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IGetConnectPriceRequestDto {
    needInt: 0 | 1,
    needTv: 0 | 1,
    int100: 0 | 1,
    install: 0 | 1 | 2, // Какие стоимости вернуть (0 - только стоимость доставки, 1 - стоимость установки, 2 - стоимость доставки и стоиомсть установки)
}

export interface IGetConnectPriceResponseDto {
    del_action_price: number,
    del_base_price: number,
    action_price: number,
    base_price: number,
}

/**
 * Стоимость стоимости доставки и установки полной покупки оборудования
 * @link https://kb.ertelecom.ru/pages/viewpage.action?pageId=171217453#id-%D0%95%D0%9B%D0%9A.API.%D0%91%D0%B0%D0%BB%D0%B0%D0%BD%D1%81%D1%8B,%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B8,%D0%BD%D0%B0%D1%87%D0%B8%D1%81%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F-%D0%A1%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D1%8F
 * @link https://master.api-request.sandbox.d2c.r-one.io/docs/v1#/%D0%A1%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C%20%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D1%8F%20%D0%B4%D0%BB%D1%8F%20%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82%D0%BE%D0%B2%20%D0%98%D0%BD%D1%82%D0%B5%D1%80%D0%BD%D0%B5%D1%82%20%D0%B8%20%D0%A2%D0%92/41d8d832e5a2e59a0ced900a019463be
 */
export const getConnectPrice = (queryParams: IGetConnectPriceRequestDto): IRequest => ({
    uri: '/v1/get-connect-price',
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams,
});
